import mockAxios, { AxiosResponse } from 'axios';
import { IMaintenanceServiceMock } from './maintenance.mock.types';

export const mockMaintenanceService = (): IMaintenanceServiceMock => ({
  fetchMaintenances: jest.fn(),
  fetchMaintenance: jest.fn(),
  createMaintenance: jest.fn(),
  updateMaintenance: jest.fn(),
  deleteMaintenance: jest.fn()
});

export const mockMaintenanceAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
